import { useEffect, useContext } from 'react';
import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import { usePlanAccess } from '../../components/gating/PlanGate';
import RoleManagementContext from '../../context/roleManagement/RoleManagementContext';
import RoleManagementHeader from './sections/Header/RoleManagementHeader';
import RoleMemberList from './sections/MemberList/RoleMemberList';
import AccessRestricted from './sections/Shared/AccessRestricted';

const RoleManagementPage = () => {
  const { isLocked: isRolesLocked } = usePlanAccess('enterprise');
  const {
    members,
    filteredMembers,
    loading,
    searchQuery,
    setSearchQuery,
    currentUserRole,
    isRestricted,
    fetchMembers,
    deleteMember
  } = useContext(RoleManagementContext);

  useEffect(() => {
    if (!isRolesLocked && (currentUserRole === 'admin' || currentUserRole === 'subadmin')) {
      fetchMembers(isRolesLocked);
    }
  }, [isRolesLocked, currentUserRole, fetchMembers]);

  return (
    <MainLayout activeTab="role-management">
      <PageContainer className="font-sans">
        <RoleManagementHeader isRestricted={isRestricted} />

        {isRestricted ? (
          <AccessRestricted currentUserRole={currentUserRole} />
        ) : (
          <RoleMemberList
            members={members}
            filteredMembers={filteredMembers}
            loading={loading}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            currentUserRole={currentUserRole}
            isRolesLocked={isRolesLocked}
            onDelete={deleteMember}
          />
        )}
      </PageContainer>
    </MainLayout>
  );
};

export default RoleManagementPage;
